import api from "@api";
import queryString from "qs";
import { ISubscriptionPlan, ISubscriptionProduct } from "../types";

export const getSubscriptionPeriod = (
  name: string
): "month" | "quarter" | "year" => {
  if (name.includes("monthly")) {
    return "month";
  }

  if (name.includes("quarterly")) {
    return "quarter";
  }

  if (name.includes("yearly")) {
    return "year";
  }
};

export const getSubscriptionProducts = async (): Promise<
  ISubscriptionPlan[]
> => {
  try {
    const { data } = await api.get<undefined, ISubscriptionPlan[]>(
      `products?${queryString.stringify({
        query: { category: "subscription" },
      })}`
    );

    return data.map((plan) => ({
      id: plan.id,
      priceCents: plan.priceCents,
      name: plan.name,
      priceCurrency: plan.priceCurrency,
      period: getSubscriptionPeriod(plan.name),
    }));
  } catch (error) {
    throw new Error(error);
  }
};

export function isSubscriptionProduct(
  value: unknown
): value is ISubscriptionProduct {
  return (
    value &&
    value.hasOwnProperty("category") &&
    (value as ISubscriptionProduct).category === "subscription"
  );
}
